import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { allEquipmentsListKey } from '@pages/ManageTemplate/services/useAllEquipmentsListQuery';

import { apiClient } from '@services/apiClient';
import { templatesListKey } from '@services/useTemplatesListQuery';

import { equipmentSettingsLogListKey } from './useEquipmentSettingsLogListInfiniteQuery';

const deleteTemplateFn = (data: { recalculate_cost_saving: number; id: number }) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/template`, { data });

export const useDeleteTemplateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTemplateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [templatesListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [allEquipmentsListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
